import React, { Component } from 'react';

class Jumbotron extends Component {
    render() {
        return (
            <div className="jumbotron">
                <h1>Percent Back Calculator</h1>
                <h3>Feel The Burn</h3>
            </div>
        )
    }
}

export default Jumbotron;


// WEBPACK FOOTER //
// ./src/components/Jumbotron.js